import { deriveLocalCacheKey } from "./crypto";

let cacheKey: Uint8Array | null = null;

export function setLocalCacheKeyFromSecretKey(secretKeyX: Uint8Array): void {
  cacheKey = deriveLocalCacheKey(secretKeyX);
}

export function clearLocalCacheKey(): void {
  cacheKey = null;
}

export function getLocalCacheKey(): Uint8Array | null {
  return cacheKey;
}
